//
//
//
//
//
//
//
//
//
//
//
//

import Linkable from "../../mixins/Linkable";
import Loadable from "../../mixins/Loadable";
import BtnMixin from "./BtnMixin";
import {formatDimension} from "../../helpers/format_helpers";
const LoadingIcon = () => import('../Icon/LoadingIcon')

export default {
    name: "Btn",
    components: {LoadingIcon},
    mixins: [BtnMixin, Linkable, Loadable],

    data() {
        return {
            // Required to keep the button width when loading
            loadingWidth: null,
            showLoadingIcon: false
        }
    },

    computed: {

        tag() {
            if (this.absoluteTo) {
                return 'a';
            }
            if (this.relativeTo) {
                return 'nuxt-link';
            }

            return 'button';
        },

        isDisabled() {
            return this.isLoading || this.disabled;
        },

        style() {
            const style = {};

            if (this.colorHex && (this.outlined || this.text)) {
                style.color = this.colorHex;
            }
            if (this.colorHex && !this.outlined && !this.text) {
                style.backgroundColor = this.colorHex;
            }

            if (this.loadingWidth) {
                style.width = formatDimension(this.loadingWidth)
                style.maxWidth = formatDimension(this.loadingWidth)
            }

            return style;
        }
    },

    watch: {
        isLoading(loading) {
            this.setLoadingIcon(loading);
        }
    },

    methods: {
        handleClick(event) {
            if (!this.disabled) {
                this.$emit('click', event)
            }
        },

        setLoadingIcon(loading) {
            if (loading) {
                this.loadingWidth = this.$el ? this.$el.getBoundingClientRect().width : null;
                this.showLoadingIcon = true;
            } else {
                this.loadingWidth = null;
                this.showLoadingIcon = false;
            }
        }
    }
}
